module.exports = {
      id: "telegramicon-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#telegramicon",
      toString: function () {
        return this.url;
      }
    }